"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCardConfig = void 0;
var getText_1 = require("../../../utils/getText");
var getVal_1 = require("../../../utils/getterSetterDeleter/getVal");
var stitchLink_1 = require("../../../utils/stitchLink");
var createFormattedDate_1 = require("../../../utils/momentjs/createFormattedDate");
var parseCardConfig = function (_a) {
    var _b, _c, _d;
    var config = _a.config, data = _a.data, _e = _a.parseSpecialSyntax, parseSpecialSyntax = _e === void 0 ? function () { return undefined; } : _e;
    var title = config.title && (0, getText_1.getText)((0, getVal_1.getVal)(data, config.title)); //getText converts richtext into plain. and leaves plain text unchanged
    var titleOptional = config.titleOptional && (0, getText_1.getText)((0, getVal_1.getVal)(data, config.titleOptional));
    var desc = config.desc && (0, getText_1.getText)((0, getVal_1.getVal)(data, config.desc));
    var cardLabel = config.cardLabel &&
        (parseSpecialSyntax({ string: config.cardLabel, content: data }) ||
            (0, getVal_1.getVal)(data, config.cardLabel));
    var video = config.video && (0, getVal_1.getVal)(data, config.video);
    var tagDisplay = config.tagDisplay && (0, getVal_1.getVal)(data, config.tagDisplay);
    var image = config.image && (0, getVal_1.getVal)(data, ((_b = config.image) === null || _b === void 0 ? void 0 : _b.valuePath) || config.image); // cuz image config could be either `image: <valuePath>` or `image: { valuePath: <valuePath>, aspectRatio: <aspectRatio> }`
    var imageAspectRatio = (_c = config.image) === null || _c === void 0 ? void 0 : _c.aspectRatio;
    return {
        title: title,
        titleOptional: titleOptional,
        desc: desc,
        cardLabel: cardLabel,
        video: video,
        image: image,
        imageAspectRatio: imageAspectRatio,
        metaBlock: (_d = config.metaBlock) === null || _d === void 0 ? void 0 : _d.slice(0, 2), //metablock in cards doesnt accept more than 2 configs
        tagDisplay: tagDisplay,
    };
};
exports.parseCardConfig = parseCardConfig;
